import React from "react";
import { ProductDto } from "../../api/products";
import "../../styles/pages/product-detail.css";

interface Props {
  open: boolean;
  item?: ProductDto | null;
  onClose: () => void;
}

export default function ProductDetailModal({ open, item, onClose }: Props) {
  if (!open || !item) return null;

  const img = item.imageUrl
    ? (item.imageUrl.startsWith("http")
        ? item.imageUrl
        : `${item.imageUrl}`)
    : null;

  return (
    <div className="modal-backdrop" onClick={onClose} role="dialog" aria-modal="true">
      <div className="modal modal-card modal-product" onClick={(e) => e.stopPropagation()}>

        {/* HEADER */}
        <div className="modal-header">
          <h3 className="modal-title">Просмотр товара</h3>
          <button className="icon-btn" onClick={onClose}>✕</button>
        </div>

        {/* GRID */}
        <div className="modal-body product-grid">

          {/* LEFT — IMAGE */}
          <div className="product-left">
            <div className="product-preview">
              {img ? (
                <img src={img} alt={item.nameRu} />
              ) : (
                <div className="product-detail-noimage">Нет изображения</div>
              )}
            </div>
          </div>

          {/* RIGHT — INFO */}
          <div className="product-right">

            <div className="field-row">
              <label className="field-label">Название (RU)</label>
              <div className="field-value">{item.nameRu}</div>
            </div>

            {item.sku && (
              <div className="field-row">
                <label className="field-label">SKU</label>
                <div className="field-value">{item.sku}</div>
              </div>
            )}

            {item.barcode && (
              <div className="field-row">
                <label className="field-label">Штрихкод</label>
                <div className="field-value">{item.barcode}</div>
              </div>
            )}

            <div className="field-row">
              <label className="field-label">Цена</label>
              <div className="field-value">{item.salePrice} ₸</div>
            </div>
          </div>
        </div>

        {/* DESCRIPTION */}
        <div className="modal-body">
          <label className="modal-field">
            <span className="modal-field-label">Описание</span>
            <div className="field-value description-block">
              {item.descriptionRu || <em>Описание отсутствует</em>}
            </div>
          </label>
        </div>

      </div>
    </div>
  );
}
